import "./CarrinhoResumo.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { getMultiplicadorVenda } from "../../../../components/utils/produtoVenda";

export default function CarrinhoResumo({
  produtos,
  limitecrdt,
  codcliente,
  razaosocial,
  codplano,
  codrepresentante,
  setProdutos,
  setMensagemPedido
}) {

  // console.log(codcliente, razaosocial, codplano, codrepresentante)
  const [enviando, setEnviando] = useState(false);
  const [tipoMensagem, setTipoMensagem] = useState("erro");
  const [mensagem, setMensagem] = useState("");

  const quantidadeItens =
    produtos.reduce((total, item) => {

      const quantidade = Number(item.quantidade);

      const multiplicador =
        item.ehCaixa
          ? Number(item.pesoCaixa)
          : item.ehPesoPorPeca
            ? Number(item.pesoPeca)
            : 1;

      return total + quantidade * multiplicador;

    }, 0);

  const pesoBruto =
    produtos.reduce((total, item) => {

      const multiplicador =
        getMultiplicadorVenda(item);

      return total +
        Number(item.pesob || 0) *
        Number(item.quantidade) *
        multiplicador;

    }, 0);

  const pesoLiquido =
    produtos.reduce((total, item) => {

      const multiplicador =
        getMultiplicadorVenda(item);

      return total +
        Number(item.pesol || 0) *
        Number(item.quantidade) *
        multiplicador;

    }, 0);

  const subtotal =
    produtos.reduce((total, item) => {

      const multiplicador =
        getMultiplicadorVenda(item);

      return total +
        Number(item.precoUnitario) *
        Number(item.quantidade) *
        multiplicador;

    }, 0);



  async function fazerPedido() {
    // Comentado bloqueio pelo limite disponível
    /*
    if (subtotal > Number(limitecrdt)) {
      setTipoMensagem("erro");
      setMensagem(
        "O valor do pedido excede o limite de crédito disponível."
      );
      return;
    }
    */

    if (enviando) return;

    setEnviando(true);

    setTipoMensagem("");
    setMensagem("");

    if (!codcliente || !codrepresentante || !codplano) {
      setTipoMensagem("erro");
      setMensagem("Dados do cliente inválidos.");
      return;
    }



    try {
      const dataFatura = new Date();
      dataFatura.setDate(dataFatura.getDate() + 1);

      const hoje = dataFatura
        .toLocaleDateString("en-CA");

      const body = {
        codcliente: Number(codcliente),
        codrepresentante: Number(codrepresentante),
        codplano: Number(codplano),
        codtransportadora: 1,
        dtfatura: hoje,
        valorpedido: subtotal.toFixed(2),
        totalproduto: subtotal.toFixed(2),
        qtdtotal: quantidadeItens,
        descliente: razaosocial,
        codusuario: 1,
        peso: Number(pesoBruto.toFixed(3)),
        pesoL: Number(pesoLiquido.toFixed(3)),
        status: 1,
        tipoped: 4,
        situacao: 0,
        produtos: produtos.map((item, index) => {

          const quantidadePedido =
            Number(item.quantidade) *
            getMultiplicadorVenda(item);

          return {
            seq: index + 1,

            qtde: quantidadePedido,

            CodItem: String(item.codProduto),

            precounitario: Number(item.precoUnitario),

            precototal: Number(
              (
                quantidadePedido *
                Number(item.precoUnitario)
              ).toFixed(2)
            ),

            datafatur: hoje,
            nropedido: "",
            descricao: item.descricao,
          };

        }),
      };

      console.log("Body Pedido:", body);

      const res = await axios.post(
        "https://palm.eliandroalimentos.com.br/api/app_vendas/gerarnovopedido",
        body
      );

      console.log("Resposta:", res.data);

      const dados = res.data;

      if (
        dados?.sucesso === true &&
        dados?.pedido !== undefined &&
        dados?.pedido !== null
      ) {
        setTipoMensagem("sucesso");

        setProdutos([]);

        setMensagemPedido(
          `Pedido ${dados.pedido} gerado com sucesso.`
        );

        // Limpa o carrinho
        localStorage.removeItem("carrinho");

        window.dispatchEvent(
          new Event("carrinhoAtualizado")
        );
      } else {
        setTipoMensagem("erro");
        setMensagem("Erro ao fazer pedido.");
      }
    } catch (error) {
      console.error(error);

      setTipoMensagem("erro");

      if (axios.isAxiosError(error)) {
        setMensagem(
          error.response?.data?.mensagem ||
          error.response?.data?.error ||
          "Erro ao fazer pedido."
        );
      } else {
        setMensagem("Erro ao fazer pedido.");
      }
    } finally {
      setEnviando(false);
    }
  }

  return (
    <aside className="resumo-carrinho">

      <h2>
        Resumo do Pedido
      </h2>

      <div className="linha-resumo">
        <span>Itens</span>

        <strong>
          {quantidadeItens}
        </strong>
      </div>

      <div className="linha-resumo">
        <span>
          Peso Bruto
        </span>

        <strong>
          {pesoBruto.toLocaleString(
            "pt-BR",
            {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3,
            }
          )}
          kg
        </strong>
      </div>

      <div className="linha-resumo">
        <span>
          Peso Líquido
        </span>

        <strong>
          {pesoLiquido.toLocaleString(
            "pt-BR",
            {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3,
            }
          )}
          kg
        </strong>
      </div>

      <hr />

      <div className="linha-resumo total">

        <span>Total</span>

        <strong>

          R${" "}

          {subtotal.toLocaleString(
            "pt-BR",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          )}

        </strong>

      </div>

      <button
        className="btn-finalizar"
        onClick={fazerPedido}
        disabled={enviando}
      >
        {enviando ? "Enviando..." : "Fazer Pedido"}
      </button>

      <div className={`mensagem-item ${tipoMensagem}`}>
        {mensagem}
      </div>

    </aside>
  );
}